import { render, staticRenderFns } from "./LeadCommunicationMessage.vue?vue&type=template&id=3ed7e5d8&scoped=true&"
import script from "./LeadCommunicationMessage.vue?vue&type=script&lang=js&"
export * from "./LeadCommunicationMessage.vue?vue&type=script&lang=js&"
import style0 from "./LeadCommunicationMessage.vue?vue&type=style&index=0&id=3ed7e5d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed7e5d8",
  null
  
)

export default component.exports